import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageSerch from "../SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import { encryptId, loginapi } from "../../../services/apiService"; // Adjust the import path as needed
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Add this import for eye icons
import { oneKlicks, sendSMS } from "../../../SDK/oneclick";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Link } from "react-router-dom";
import { useAuth } from '../../../context/AuthContext';

const LoginScreen = () => {
    const navigate = useNavigate();
    const { login, isLoggedIn, userData } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loginbutton, setLoginbutton] = useState(false);
    const [errors, setErrors] = useState({
        email: "",
        password: "",
        phone: ""
    });
    const [phoneNumber, setPhoneNumber] = useState("");
    const [user, setUser] = useState(null);
    const [showOtpForm, setShowOtpForm] = useState(false);
    const [otp, setOtp] = useState("");
    const [tempUserData, setTempUserData] = useState(null);
    const [loginMethod, setLoginMethod] = useState('email');
    const [resendTimer, setResendTimer] = useState(0);
    const [canResendOtp, setCanResendOtp] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        checklogin();
        let timer;
        if (resendTimer > 0) {
            timer = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        setCanResendOtp(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [resendTimer]);


    const checklogin = async () => {
        if (isLoggedIn) {
            handleNavigation(userData);
        } else {
            navigate("/login");
        }
    }

    const startResendTimer = () => {
        setResendTimer(60);
        setCanResendOtp(false);
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            email: "",
            password: "",
            phone: ""
        };

        if (loginMethod === 'email') {
            if (!email.trim()) {
                newErrors.email = "Email is required";
                isValid = false;
            } else if (!/\S+@\S+\.\S+/.test(email)) {
                newErrors.email = "Please enter a valid email address";
                isValid = false;
            }

            if (!password) {
                newErrors.password = "Password is required";
                isValid = false;
            } else if (password.length < 6) {
                newErrors.password = "Password must be at least 6 characters";
                isValid = false;
            }
        } else {
            if (!phoneNumber) {
                newErrors.phone = "Phone number is required";
                isValid = false;
            }
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        try {
            if (loginMethod === 'email') {
                console.log('Attempting email login...');
                const loginResponse = await loginapi(email, password);
                console.log('Login response:', loginResponse);

                if (loginResponse.success && loginResponse.data && loginResponse.data.length > 0) {
                    const user = loginResponse.data[0];
                    if (user.status === "2") {
                        toast.error("Your account has been deleted. Please contact support.");
                        return;
                    }

                    const userData = {
                        id: user.id,
                        email: user.email,
                        user_type: user.user_type,
                        display_name: user.display_name || user.name || user.email
                    };

                    console.log('User data prepared for login:', userData);
                    // Use the login function from AuthContext
                    const loginSuccess = await login(userData);
                    console.log('Login success status:', loginSuccess);

                    if (loginSuccess) {
                        localStorage.setItem('userData', JSON.stringify(userData));
                        localStorage.removeItem('presentuser');
                        toast.success("Login successful!", { autoClose: 2000 });
                        handleNavigation(userData);
                    } else {
                        console.error('Login failed - login function returned false');
                        toast.error("Login failed. Please try again.");
                    }
                } else {
                    console.error('check login data parmaa');
                    toast.error(loginResponse.message || "Invalid credentials. Please try again.");
                }
            } else {
                // Phone login logic (Priority: Specialized Tables First)
                const tablesToCheck = ['pharmacies', 'blood_bank', 'diagnostics', 'users'];
                let userFound = false;

                for (const tableName of tablesToCheck) {
                    try {
                        const tableSchema = "";
                        const conditions = { phone: phoneNumber };
                        const orderBy = "id DESC";
                        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");

                        if (response.success && response.data.length > 0) {
                            const user = response.data[0];
                            userFound = true;
                            const generatedOtp = Math.floor(100000 + Math.random() * 900000);

                            try {
                                const body = `Hey! Here's your MeddyList verification code: ${generatedOtp}. Use it to continue. Keep it secure!`;
                                const message = await sendSMS(phoneNumber, body);

                                if (message.sid) {
                                    const data = {
                                        otp: generatedOtp,
                                        otp_expiry: new Date(Date.now() + 10 * 60000)
                                    };
                                    const condition = { phone: phoneNumber };

                                    const storeOtpResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                                    if (storeOtpResponse.success) {
                                        setTempUserData({ phone: phoneNumber, id: user.id });
                                        setShowOtpForm(true);
                                        startResendTimer();
                                        localStorage.setItem('presentuser', JSON.stringify({ phone: phoneNumber, id: user.id }));
                                        toast.success("OTP sent to your phone number", { autoClose: 3000 });
                                    } else {
                                        toast.error("Failed to store OTP. Please try again.");
                                    }
                                }
                            } catch (twilioError) {
                                console.error("Twilio error:", twilioError);
                                toast.error("Failed to send OTP. Please try again.");
                            }
                            break; // Stop checking other tables if user is found
                        }
                    } catch (tableError) {
                        console.log(`Error checking ${tableName}:`, tableError);
                    }
                }

                if (!userFound) {
                    toast.error("Phone number not found. Please check and try again.");
                }
            }
        } catch (error) {
            console.error("Login error:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const verifyOtp = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            // Helper to check OTP in a table
            const checkTable = async (tableName) => {
                const conditions = { phone: tempUserData.phone, otp: otp };
                const response = await oneKlicks.read("", tableName, conditions, "", "", "", "");

                if (response.success && response.data.length > 0) {
                    const user = response.data[0];

                    // Check expiry if the field exists
                    if (user.otp_expiry) {
                        const otpExpiry = new Date(user.otp_expiry);
                        if (otpExpiry < new Date()) {
                            toast.error("OTP has expired. Please request a new one.");
                            return { found: true, expired: true };
                        }
                    }

                    // Inject user_type if missing
                    if (!user.user_type) {
                        if (tableName === 'pharmacies') user.user_type = 'pharmacy';
                        else if (tableName === 'blood_bank') user.user_type = 'blood_bank';
                        else if (tableName === 'diagnostic' || tableName === 'diagnostics') user.user_type = 'diagnostic';
                        else if (tableName === 'ambulances') user.user_type = 'ambulance';
                    }
                    return { found: true, user };
                }
                return { found: false };
            };

            // Try all potential tables (Priority: Specialized First)
            let result = await checkTable('pharmacies');
            if (!result.found) result = await checkTable('blood_bank');
            if (!result.found) result = await checkTable('diagnostics');
            if (!result.found) result = await checkTable('users');

            if (result.found) {
                if (result.expired) return;

                const userData = result.user;
                // Login
                const loginSuccess = await login({
                    id: userData.id,
                    email: userData.email || "",
                    user_type: userData.user_type,
                    display_name: userData.display_name || userData.name || userData.email || userData.phone
                });

                if (loginSuccess) {
                    setShowOtpForm(false);
                    // Store correct session data matching apiService expectations
                    localStorage.setItem('userData', JSON.stringify({ ...userData }));
                    localStorage.removeItem('presentuser');
                    toast.success("Login successful!", { autoClose: 2000 });
                    handleNavigation(userData);
                } else {
                    toast.error("Login failed. Please try again.");
                }
                return;
            }

            toast.error("Invalid OTP. Please try again.");

        } catch (error) {
            console.error("OTP verification error:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const resendOtp = async () => {
        if (!canResendOtp) return;

        try {
            const generatedOtp = Math.floor(100000 + Math.random() * 900000);
            const tableSchema = "";
            const tableName = "users";

            const body = `Here's your MeddyList code again: ${generatedOtp}. Use it within 10 minutes. Need help? Reply to this message.`;

            const message = await sendSMS(phoneNumber, body);

            if (message.sid) {
                const data = {
                    otp: generatedOtp,
                    otp_expiry: new Date(Date.now() + 10 * 60000)
                };
                const condition = {
                    phone: tempUserData.phone
                };

                const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);

                if (updateResponse.success) {
                    startResendTimer();
                    toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                } else {
                    const tableSchema = "";
                    const tableName = "pharmacies";
                    const conditions = {
                        phone: tempUserData.phone
                    };
                    const orderBy = "id DESC";
                    const phoneLoginResponse = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, "", "", "");
                    if (phoneLoginResponse.data.length > 0) {
                        const user = phoneLoginResponse.data[0];
                        const generatedOtp = Math.floor(100000 + Math.random() * 900000);
                        const data = {
                            otp: generatedOtp,
                            otp_expiry: new Date(Date.now() + 10 * 60000)
                        };
                        const condition = {
                            phone: tempUserData.phone
                        };
                        const updateResponse = await oneKlicks.update(tableSchema, tableName, data, condition);
                        if (updateResponse.success) {
                            toast.success("New OTP sent to your phone number", { autoClose: 3000 });
                        }
                    } else {
                        toast.error("Failed to update OTP. Please try again.");
                    }

                }
            }
        } catch (error) {
            console.error("Resend OTP error:", error);
            toast.error("Failed to resend OTP. Please try again.");
        }
    };

    const handleNavigation = (userData) => {
        console.log("Navigating user:", userData);
        const userType = userData.user_type?.toLowerCase();

        if (!userType) {
            console.error("User type missing, directing to home");
            navigate("/");
            return;
        }

        switch (userType) {
            case "admin":
                navigate("/admin-dashboard");
                break;
            case "doctor":
                navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                break;
            case "hospitals":
            case "hospital":
                navigate("/hospital/dashboard");
                break;
            case "regular_users":
            case "patient":
                navigate("/patient/dashboard");
                break;
            case "blood_bank":
                navigate("/blood-bank/dashboard");
                break;
            case "pharmacy":
                navigate("/pharmacy/dashboard");
                break;
            case "diagnostic":
                navigate("/diagnostic/dashboard");
                break;
            case "insurance":
            case "insurance_company":
                navigate("/insurance-dashboard");
                break;
            case "user":
                navigate("/");
                break;
            case "administrator":
                navigate("/superadmin/dashboard");
                break;
            case "staff":
                navigate("/superadmin/dashboard");
                break;
            case "editor":
                navigate("/editor/dashboard");
                break;
            default:
                console.warn(`Unknown user type: ${userType}`);
                navigate("/");
                break;
        }
    };

    return (
        <>
            <PageSerch />
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="container">
                    <div className="dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                        <div className="main-page-wrapper">
                            <div className="row">
                                <div className="col-lg-6 col-md-12 login images" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <img
                                        decoding="async"
                                        alt="Login illustration"
                                        src="//css.meddylist.com//wp-content/uploads/2019/08/img-01-1.png"
                                        style={{ maxWidth: '80%', maxHeight: '100%' }}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="dc-modalcontent modal-content login_bodey">
                                        <div className="dc-loginformholds">
                                            <div className="dc-loginheader">
                                                <span>Login</span>
                                            </div>
                                            {!showOtpForm ? (
                                                <form className="dc-formtheme dc-loginform">
                                                    <fieldset>
                                                        {loginMethod === 'email' ? (
                                                            <>
                                                                <div className="form-group">
                                                                    <input
                                                                        type="email"
                                                                        name="email"
                                                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                        placeholder="Email"
                                                                        value={email}
                                                                        onChange={(e) => {
                                                                            setEmail(e.target.value);
                                                                            setErrors(prev => ({ ...prev, email: "" }));
                                                                        }}
                                                                    />
                                                                    {errors.email && (
                                                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                            {errors.email}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="form-group position-relative">
                                                                    <input
                                                                        type={showPassword ? "text" : "password"}
                                                                        name="password"
                                                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                                        placeholder="Password"
                                                                        value={password}
                                                                        onChange={(e) => {
                                                                            setPassword(e.target.value);
                                                                            setErrors(prev => ({ ...prev, password: "" }));
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link position-absolute"
                                                                        style={{
                                                                            right: '10px',
                                                                            top: '23px',
                                                                            transform: 'translateY(-50%)',
                                                                            padding: '0',
                                                                            color: '#666'
                                                                        }}
                                                                        onClick={togglePasswordVisibility}
                                                                    >
                                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                                    </button>
                                                                    {errors.password && (
                                                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                            {errors.password}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <PhoneInput
                                                                international
                                                                defaultCountry="IN"
                                                                value={phoneNumber}
                                                                onChange={setPhoneNumber}
                                                                placeholder="Enter phone number"
                                                                className="form-control frontend-phone-input"
                                                            />
                                                        )}


                                                        <div className="dc-logininfo">
                                                            <button
                                                                type="submit"
                                                                className="dc-btn do-login-button"
                                                                onClick={handleLogin}
                                                                disabled={isLoading}
                                                                style={{ position: 'relative', minWidth: '120px' }}
                                                            >
                                                                {isLoading ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        Loading...
                                                                    </>
                                                                ) : (
                                                                    loginMethod === 'email' ? 'Login' : 'Send OTP'
                                                                )}
                                                            </button>


                                                            {loginMethod === 'email' ? (
                                                                <a href="#" style={{ float: 'right' }} className={`dc-btn do-login-button ${loginMethod === 'phone' ? 'active' : ''}`}
                                                                    onClick={() => setLoginMethod('phone')}
                                                                >
                                                                    Phone Login
                                                                </a>
                                                            ) : (
                                                                <a href="#" style={{ float: 'right' }}
                                                                    className={`dc-btn do-login-button ${loginMethod === 'email' ? 'active' : ''}`}
                                                                    onClick={() => setLoginMethod('email')}
                                                                >
                                                                    Email Login
                                                                </a>

                                                            )}
                                                        </div>
                                                    </fieldset>
                                                    <div className="dc-loginfooterinfo">
                                                        <Link to="/forgot-password" className="dc-forgot-password" >Forgot password?</Link>
                                                        <Link to="/login">Login</Link>
                                                    </div>
                                                </form>
                                            ) : (
                                                <form className="dc-formtheme dc-loginform do-login-form">
                                                    <fieldset>
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                name="otp"
                                                                value={otp}
                                                                onChange={(e) => setOtp(e.target.value)}
                                                                className="form-control"
                                                                placeholder="Enter 6-digit OTP"
                                                                maxLength="6"
                                                            />
                                                        </div>
                                                        <div className="dc-logininfo">
                                                            <button
                                                                type="submit"
                                                                className="dc-btn do-login-button"
                                                                onClick={verifyOtp}
                                                                disabled={isLoading}
                                                                style={{ position: 'relative', minWidth: '120px' }}
                                                            >
                                                                {isLoading ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        Verifying...
                                                                    </>
                                                                ) : (
                                                                    'Verify OTP'
                                                                )}
                                                            </button>
                                                        </div>
                                                    </fieldset>
                                                    <div className="dc-loginfooterinfo">
                                                        <Link to="/login" onClick={() => setShowOtpForm(false)}>Back to Login</Link>
                                                        <Link
                                                            href="#"
                                                            onClick={resendOtp}
                                                            className={`dc-forgot-password ${!canResendOtp ? 'disabled' : ''}`}
                                                            style={{
                                                                opacity: canResendOtp ? 1 : 0.5,
                                                                cursor: canResendOtp ? 'pointer' : 'not-allowed',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            {resendTimer > 0
                                                                ? `Resend OTP in ${formatTime(resendTimer)}`
                                                                : 'Resend OTP'}
                                                        </Link>
                                                    </div>
                                                </form>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};


export default LoginScreen;
